import { readonly } from "vue"

export const useQuestions = (tendencyTexts) => {
  const tendencyCount = tendencyTexts.length
  const questionAllCount = tendencyCount
  const tendencies = (index) => {
    return tendencyTexts[index]
  }

  const isTendencyQuestion = (order) => {
    return order <= tendencyCount
  }

  const isLastQuestion = (order) => {
    return order === questionAllCount
  }

  return { questionAllCount: readonly(questionAllCount), tendencies, isLastQuestion }
}